import { AboutUS } from "../components/Aboutus/AboutUs";

function AboutPage() {
  return (
    <>
      <br />
      <AboutUS></AboutUS>
    </>
  );
}
export default AboutPage;
